/**
 * @generated SignedSource<<2033840bfab8126c10defb61a471cb02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AncestryRelationship = "ANCESTOR" | "DESCENDANT" | "DIRECT_REPORT" | "MANAGER" | "OTHER" | "SELF" | "SIBLING";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type StreamAccessType = "full" | "partial" | "shared";
export type TemplateVisibility = "GLOBAL" | "HIDDEN" | "USER" | "WORKSPACE";
export type StreamSettingsModalQuery$variables = {
  streamId: string;
};
export type StreamSettingsModalQuery$data = {
  readonly automations: ReadonlyArray<{
    readonly codeName: string;
    readonly description: string;
    readonly id: string;
    readonly name: string;
  }>;
  readonly stream: {
    readonly __typename: "NoteStream";
    readonly automationConfigurations: ReadonlyArray<{
      readonly automation: {
        readonly codeName: string;
      };
      readonly id: string;
      readonly isActive: boolean;
      readonly stream: {
        readonly hasAnyAutomationActive: boolean;
        readonly id: string;
      };
      readonly tasks: ReadonlyArray<{
        readonly __typename: string;
        readonly data?: {
          readonly addBanner: boolean;
          readonly allParticipants: boolean;
          readonly channelId: string;
          readonly channelName: string;
          readonly conversation: string;
          readonly conversationName: string;
          readonly emails?: ReadonlyArray<string>;
          readonly includeAiSummary: boolean;
          readonly isUser: boolean;
          readonly message: string;
          readonly notificationPath: string;
          readonly sendNotificationTo: string;
          readonly slackTeamId: string | null;
          readonly team: string;
          readonly teamName: string;
          readonly type: string;
          readonly userIds?: ReadonlyArray<string>;
          readonly zoomChannelId: string;
          readonly zoomChannelName: string;
        };
        readonly delta: number;
        readonly id: string;
      }>;
    }> | null;
    readonly carryActionItems: boolean | null;
    readonly carryActionItemsAsLinks: boolean;
    readonly carryForwardWithNestedBlocks: boolean;
    readonly carryTalkingPoints: boolean | null;
    readonly description: string;
    readonly displayName: string;
    readonly id: string;
    readonly isExternal: boolean;
    readonly isMeetingFeedbackAnonymous: boolean;
    readonly isMeetingFeedbackPromptEnabled: boolean;
    readonly isMeetingFeedbackTabEnabled: boolean;
    readonly notestreamusers: ReadonlyArray<{
      readonly accessType: StreamAccessType;
      readonly id: string;
      readonly user: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isGuest: boolean;
      };
    }>;
    readonly objectivesFilterAssignee: any | null;
    readonly objectivesFilterCycle: any | null;
    readonly objectivesFilterStatus: string | null;
    readonly objectivesTabEnabled: boolean | null;
    readonly openActionItemCount: number;
    readonly otherUser: {
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isTopUser: boolean;
      readonly relationshipToViewer: AncestryRelationship | null;
    } | null;
    readonly tabs: ReadonlyArray<{
      readonly icon: string | null;
      readonly id: string;
      readonly isEmbedded: boolean;
      readonly order: number;
      readonly otherStreamId: string | null;
      readonly title: string;
      readonly url: string | null;
    }>;
    readonly template: {
      readonly author: {
        readonly " $fragmentSpreads": FragmentRefs<"TemplateAuthor_Author">;
      } | null;
      readonly id: string;
      readonly proseDoc: any;
      readonly schemaVersion: number;
      readonly summary: string;
      readonly tags: ReadonlyArray<string>;
      readonly title: string;
      readonly viewerCanEdit: boolean;
      readonly visibility: TemplateVisibility;
    } | null;
    readonly type: NoteStreamType;
    readonly " $fragmentSpreads": FragmentRefs<"CalendarEvents_NoteStream">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly viewer: {
    readonly account: {
      readonly allowExternalInviting: boolean | null;
      readonly allowInviting: boolean | null;
      readonly allowMeetingRecording: boolean;
      readonly billingAccount: {
        readonly hasAccessToMeetingAutomations: boolean;
        readonly hasAccessToMeetingRecorderFeature: boolean;
        readonly hasAccessToObjectives: boolean;
        readonly hasAccessToPromptHeadings: boolean;
        readonly subscriptionBillingCycleAnchor: string | null;
      };
      readonly guestUsersAllowInvite: boolean;
      readonly integrations: {
        readonly zoomBot: {
          readonly isConnected: boolean;
        } | null;
      };
    };
    readonly hasAccessToScheduledMeetingRecordings: boolean;
    readonly hasAdminAccess: boolean;
    readonly integrations: {
      readonly office365: {
        readonly id: string;
      } | null;
      readonly slack: ReadonlyArray<{
        readonly scopes: string;
      } | null> | null;
    };
    readonly remainingMeetingRecordingCredits: number;
    readonly user: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly isGuest: boolean;
    };
    readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer" | "StreamAutoRecordAutomationConfig_viewer">;
  };
};
export type StreamSettingsModalQuery = {
  response: StreamSettingsModalQuery$data;
  variables: StreamSettingsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingMeetingRecordingCredits",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAdminAccess",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccessToScheduledMeetingRecordings",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "OfficeUserNode",
  "kind": "LinkedField",
  "name": "office365",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopes",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowInviting",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guestUsersAllowInvite",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExternalInviting",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowMeetingRecording",
  "storageKey": null
},
v16 = {
  "alias": "hasAccessToPromptHeadings",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "prompt_headings"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"prompt_headings\")"
},
v17 = {
  "alias": "hasAccessToMeetingRecorderFeature",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "meeting_recorder"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
},
v18 = {
  "alias": "hasAccessToMeetingAutomations",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "meeting_automations"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"meeting_automations\")"
},
v19 = {
  "alias": "hasAccessToObjectives",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "objectives"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"objectives\")"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionBillingCycleAnchor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "codeName",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "AutomationNode",
  "kind": "LinkedField",
  "name": "automations",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/)
  ],
  "storageKey": null
},
v26 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamId"
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carryTalkingPoints",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carryActionItems",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carryActionItemsAsLinks",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carryForwardWithNestedBlocks",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedbackTabEnabled",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedbackPromptEnabled",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedbackAnonymous",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesTabEnabled",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterAssignee",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterStatus",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterCycle",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openActionItemCount",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamUser",
  "kind": "LinkedField",
  "name": "notestreamusers",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accessType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v9/*: any*/),
        (v8/*: any*/),
        (v43/*: any*/),
        (v10/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanEdit",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proseDoc",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schemaVersion",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "stream",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAnyAutomationActive",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendNotificationTo",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationPath",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allParticipants",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackTeamId",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channelId",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channelName",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversation",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversationName",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUser",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomChannelId",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomChannelName",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeAiSummary",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "tasks",
  "plural": true,
  "selections": [
    (v27/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "delta",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSaverReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addBanner",
              "storageKey": null
            },
            (v54/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSaverReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSaverCancellation",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            (v54/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSaverCancellationAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/),
            (v57/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userIds",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "EmailReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SlackReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/),
            (v58/*: any*/),
            (v59/*: any*/),
            (v60/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "SlackReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MSTeamsReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/),
            (v61/*: any*/),
            (v62/*: any*/),
            (v63/*: any*/),
            (v64/*: any*/),
            (v65/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MSTeamsReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/),
            (v66/*: any*/),
            (v67/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ZoomReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/),
            (v57/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emails",
              "storageKey": null
            },
            (v68/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "EmailRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SlackRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/),
            (v58/*: any*/),
            (v59/*: any*/),
            (v60/*: any*/),
            (v68/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "SlackRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MSTeamsRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/),
            (v61/*: any*/),
            (v62/*: any*/),
            (v63/*: any*/),
            (v64/*: any*/),
            (v65/*: any*/),
            (v68/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MSTeamsRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/),
            (v66/*: any*/),
            (v67/*: any*/),
            (v68/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ZoomRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PromptNotification",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v56/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "PromptNotificationAutomationTask",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "otherUser",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/),
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "relationshipToViewer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTopUser",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamTabNode",
  "kind": "LinkedField",
  "name": "tabs",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "otherStreamId",
      "storageKey": null
    },
    (v71/*: any*/),
    (v45/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmbedded",
      "storageKey": null
    },
    (v72/*: any*/)
  ],
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v75 = [
  (v22/*: any*/),
  (v74/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamSettingsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StreamAutoRecordAutomationConfig_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BillingIdentityFeaturesPaywall_viewer"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackUserNode",
                "kind": "LinkedField",
                "name": "slack",
                "plural": true,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ZoomBotNode",
                    "kind": "LinkedField",
                    "name": "zoomBot",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      {
        "alias": "stream",
        "args": (v26/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v27/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v24/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteTemplateNode",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TemplateAuthor_Author"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CalendarEvents_NoteStream"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AutomationConfigurationNode",
                "kind": "LinkedField",
                "name": "automationConfigurations",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v52/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AutomationNode",
                    "kind": "LinkedField",
                    "name": "automation",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v53/*: any*/),
                  (v69/*: any*/)
                ],
                "storageKey": null
              },
              (v70/*: any*/),
              (v73/*: any*/)
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StreamSettingsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToCopilot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featureAccess",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ZoomBotNode",
                    "kind": "LinkedField",
                    "name": "zoomBot",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackUserNode",
                "kind": "LinkedField",
                "name": "slack",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      {
        "alias": "stream",
        "args": (v26/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v27/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v24/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v44/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteTemplateNode",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isNoteTemplateAuthor"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v9/*: any*/),
                          (v43/*: any*/)
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v75/*: any*/),
                        "type": "Account",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v75/*: any*/),
                        "type": "ExternalAccount",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v43/*: any*/),
                          {
                            "alias": "fullName",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "type": "TemplateUserAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v22/*: any*/),
                          (v74/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "darkModeLogo",
                            "storageKey": null
                          }
                        ],
                        "type": "TemplateCompanyAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v71/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": "nameThatIsOptional",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "type": "TemplateIconAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v5/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "claimedEvents",
                "plural": true,
                "selections": [
                  (v28/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastRecurrenceEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "end",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "start",
                    "storageKey": null
                  },
                  (v45/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAllDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "guid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "location",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recurrenceRule",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isHidden",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrganizer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConferenceCall",
                    "kind": "LinkedField",
                    "name": "conferenceCalls",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "provider",
                        "storageKey": null
                      },
                      (v72/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pin",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AutomationConfigurationNode",
                "kind": "LinkedField",
                "name": "automationConfigurations",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v52/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AutomationNode",
                    "kind": "LinkedField",
                    "name": "automation",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v53/*: any*/),
                  (v69/*: any*/)
                ],
                "storageKey": null
              },
              (v70/*: any*/),
              (v73/*: any*/)
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2295c370f6f3f069dbfd0a90066dcdf3",
    "id": null,
    "metadata": {},
    "name": "StreamSettingsModalQuery",
    "operationKind": "query",
    "text": "query StreamSettingsModalQuery(\n  $streamId: ID!\n) {\n  viewer {\n    ...StreamAutoRecordAutomationConfig_viewer\n    ...BillingIdentityFeaturesPaywall_viewer\n    remainingMeetingRecordingCredits\n    hasAdminAccess\n    hasAccessToScheduledMeetingRecordings\n    integrations {\n      office365 {\n        id\n      }\n      slack {\n        scopes\n        id\n      }\n    }\n    user {\n      id\n      email\n      fullName\n      isGuest\n    }\n    account {\n      allowInviting\n      guestUsersAllowInvite\n      allowExternalInviting\n      allowMeetingRecording\n      billingAccount {\n        hasAccessToPromptHeadings: hasAccessToFeature(feature: prompt_headings)\n        hasAccessToMeetingRecorderFeature: hasAccessToFeature(feature: meeting_recorder)\n        hasAccessToMeetingAutomations: hasAccessToFeature(feature: meeting_automations)\n        hasAccessToObjectives: hasAccessToFeature(feature: objectives)\n        subscriptionBillingCycleAnchor\n        id\n      }\n      integrations {\n        zoomBot {\n          isConnected\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n  automations {\n    id\n    name\n    codeName\n    description\n  }\n  stream: node(id: $streamId) {\n    __typename\n    ... on NoteStream {\n      id\n      type\n      isExternal\n      displayName\n      description\n      carryTalkingPoints\n      carryActionItems\n      carryActionItemsAsLinks\n      carryForwardWithNestedBlocks\n      isMeetingFeedbackTabEnabled\n      isMeetingFeedbackPromptEnabled\n      isMeetingFeedbackAnonymous\n      objectivesTabEnabled\n      objectivesFilterAssignee\n      objectivesFilterStatus\n      objectivesFilterCycle\n      openActionItemCount\n      notestreamusers {\n        id\n        accessType\n        user {\n          id\n          fullName\n          email\n          image\n          isGuest\n        }\n      }\n      template {\n        id\n        title\n        summary\n        viewerCanEdit\n        proseDoc\n        tags\n        visibility\n        schemaVersion\n        author {\n          __typename\n          ...TemplateAuthor_Author\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n      ...CalendarEvents_NoteStream\n      automationConfigurations {\n        id\n        isActive\n        automation {\n          codeName\n          id\n        }\n        stream {\n          id\n          hasAnyAutomationActive\n        }\n        tasks {\n          __typename\n          id\n          delta\n          ... on TimeSaverReminderAutomationTask {\n            data {\n              type\n              addBanner\n              sendNotificationTo\n            }\n          }\n          ... on TimeSaverCancellationAutomationTask {\n            data {\n              type\n              sendNotificationTo\n            }\n          }\n          ... on EmailReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              allParticipants\n              userIds\n            }\n          }\n          ... on SlackReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              slackTeamId\n              channelId\n              channelName\n            }\n          }\n          ... on MSTeamsReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              team\n              teamName\n              conversation\n              conversationName\n              isUser\n            }\n          }\n          ... on ZoomReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              zoomChannelId\n              zoomChannelName\n            }\n          }\n          ... on EmailRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              allParticipants\n              emails\n              includeAiSummary\n            }\n          }\n          ... on SlackRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              slackTeamId\n              channelId\n              channelName\n              includeAiSummary\n            }\n          }\n          ... on MSTeamsRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              team\n              teamName\n              conversation\n              conversationName\n              isUser\n              includeAiSummary\n            }\n          }\n          ... on ZoomRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              zoomChannelId\n              zoomChannelName\n              includeAiSummary\n            }\n          }\n          ... on PromptNotificationAutomationTask {\n            data {\n              message\n            }\n          }\n        }\n      }\n      otherUser {\n        id\n        fullName\n        image\n        relationshipToViewer\n        isTopUser\n      }\n      tabs {\n        id\n        otherStreamId\n        icon\n        title\n        order\n        isEmbedded\n        url\n      }\n    }\n    id\n  }\n}\n\nfragment BillingIdentityFeaturesPaywall_viewer on Viewer {\n  account {\n    billingAccount {\n      featureAccess\n      id\n    }\n    id\n  }\n}\n\nfragment CalendarEventsRecurringEventCard_Event on Event {\n  id\n  start\n  end\n  title\n  recurrenceRule\n  isAllDay\n  ...CalendarEvents_meetingInfoModalEvent\n}\n\nfragment CalendarEventsSingleEventCard_Event on Event {\n  id\n  start\n  end\n  title\n  isAllDay\n  ...CalendarEvents_meetingInfoModalEvent\n}\n\nfragment CalendarEvents_NoteStream on NoteStream {\n  claimedEvents {\n    type\n    lastRecurrenceEnd\n    end\n    ...CalendarEventsSingleEventCard_Event\n    ...CalendarEventsRecurringEventCard_Event\n    id\n  }\n}\n\nfragment CalendarEvents_meetingInfoModalEvent on Event {\n  id\n  start\n  end\n  title\n  guid\n  location\n  recurrenceRule\n  isHidden\n  isOrganizer\n  isAllDay\n  conferenceCalls {\n    provider\n    url\n    phoneNumber\n    pin\n  }\n}\n\nfragment StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer on Viewer {\n  hasAccessToCopilot\n}\n\nfragment StreamAutoRecordAutomationConfig_viewer on Viewer {\n  remainingMeetingRecordingCredits\n  hasAccessToCopilot\n  ...StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer\n}\n\nfragment TemplateAuthor_Author on NoteTemplateAuthor {\n  __isNoteTemplateAuthor: __typename\n  __typename\n  ... on User {\n    id\n    fullName\n    image\n  }\n  ... on Account {\n    name\n    logo\n  }\n  ... on ExternalAccount {\n    name\n    logo\n  }\n  ... on TemplateUserAuthor {\n    image\n    fullName: name\n  }\n  ... on TemplateCompanyAuthor {\n    name\n    logo\n    darkModeLogo\n  }\n  ... on TemplateIconAuthor {\n    icon\n    color\n    nameThatIsOptional: name\n  }\n}\n"
  }
};
})();

(node as any).hash = "070a2fd54cc62d90f0cf169c5b2a2408";

export default node;
